import { eatLocalBackground } from "Constants/Require/Require";

export const membershipConstants = Object.freeze({
  SUBHEADING: "Ready to Eat Local?",
  SUBTITLE:
    "Once you Activate your Gourmet Socitey card, your membership will be active for 12 months.",
  WELCOME_SUBHEADING: "Welcome!",
  WELCOME_SUBTITLE:
    "Great! Your Eat Local membership powered by Gourmet Society is now active. Search for your favourite restaurants now.",
  LOCALBLEND_SUBHEADING: "Ready to Explore Local Blend",
  LOCALBLEND_SUBTITLE:
    "Your favourite coffees are just a tap away. Once you hit activate, you'll be a Local Blend member and can claim 25% off a range of local coffee shops. Don't forget to check that your chosen location accepts the Coffee Club offer before you use it. Once you've tapped Activate, your membership will be active for 12 months.",
  LOCALBLEND_WELCOME_SUBTITLE:
    "Great! Your Local Blend membership powered by Coffee Club is now active. Search for your favourite coffee shops now."
});
